@if (imageFullscreenView) {
  <div class="ng-image-fullscreen-view">
    <div class="lightbox-wrapper">
      <a class="close" (click)="closeLightbox()" [attr.aria-label]="'accessibility_close_image_viewer' | translate"></a>
      <div class="lightbox-div" #lightboxDiv>
        @if (showLoading) {
          <div class="pre-loader">
            <div class="mnml-spinner"></div>
          </div>
        }
        <div
          class="lightbox-image-main"
        [ngStyle]="{
          'margin-left': marginLeft + 'px',
          'grid-template-columns': 'repeat(' + images.length + ',1fr)',
          transition: effectStyle,
        }"
          >
          @for (img of images; track img; let i = $index) {
            <div
              class="lightbox-image"
              [ngStyle]="{ width: popupWidth + 'px' }"
              [attr.id]="'ng-lightbox-image-' + i"
              (touchstart)="swipeLightboxImg($event, 'start')"
              (touchend)="swipeLightboxImg($event, 'end')"
              #lightboxImageDiv
              >
              <custom-img
                [imageUrl]="img.image || img.video"
                [isVideo]="!!(img.posterImage || img.video)"
                [videoAutoPlay]="videoAutoPlay"
                [showVideoControls]="showVideoControls ? 1 : 0"
                [alt]="img.alt || img.title || 'accessibility_alt_image_preview_img' | translate"
                [title]="img.title || img.alt || ''"
                [direction]="direction"
                >
              </custom-img>
            </div>
          }
        </div>
        <div [dir]="direction" [ngClass]="{ show: title, hide: !title }" class="caption">{{ title }}</div>
        @if (images.length > 1) {
          <a
            [ngClass]="{ disable: lightboxPrevDisable }"
            class="prev icons prev-icon"
            (click)="prevImageLightbox()"
            [attr.aria-label]="'accessibility_show_previous_image' | translate"
            >
            &lsaquo;
          </a>
        }
        @if (images.length > 1) {
          <a
            [ngClass]="{ disable: lightboxNextDisable }"
            class="next icons next-icon"
            (click)="nextImageLightbox()"
            [attr.aria-label]="'accessibility_show_next_image' | translate"
            >
            &rsaquo;
          </a>
        }
      </div>
    </div>
    @if (paginationShow) {
      <div class="popup-pagination">{{ currentImageIndex + 1 }} of {{ totalImages }}</div>
    }
  </div>
}
